export const isImage = (file: File) => {
  return file.type.split('/')[0] === 'image';
};
